declare const jQuery: any;
const $ = jQuery;

// Input surround DOM must be structured in a particular way. (See nested-checkbox-group template)
export function initCheckboxToggle(): void
{
    const $inputs = $(`.checkbox-row input[type="checkbox"][data-toggle-all]`);
    if ($inputs.length === 0)
    {
        return;
    }
    $inputs.each(function () {
        const $input = $(this);
        const $subInputs = $input.parent(`.checkbox-row`).next(`.checkbox-group`).find(`input[type="checkbox"]`);
        if ($subInputs.length === 0)
        {
            console.warn(`No sub-checkboxes found for [data-checkbox-toggle]`);
            return;
        }
        if ($subInputs.length === $subInputs.filter(":checked").length)
        {
            $input.prop("checked", true).trigger("change");
        }
        $input.on("change", function () {
            // (de)select all
            $subInputs.prop("checked", $input.prop("checked")).trigger("change");
        });
    });
}
